define('app/factories/subcategories_section_factory',['app/setup', 'app/views/subcategories_section_view', 'app/views/categories_product_list_view'],
  function(takhfifan, subcategoriesSectionView) {

  	$('.tkh-subcategories-section').each(function(){
      new takhfifan.SubcategoriesSectionView({
        el: $(this)
      });
    });

    $('.tkh-category_products').each(function(){
      new takhfifan.CategoriesProductListView({
        el: $(this),
        pagesCount: $(this).data("pagesCount"),
        page: $(this).data("page")
      });
    });
});

